import { FC, Fragment, useContext, useEffect, useMemo, useState } from 'react';
import { MoSupplier as MoSupp, MoSupplierData, MyOrder } from 'ts/shared/interfaces/MOResponse';
import { useTranslation } from 'react-i18next';
import MoGroupData from './MoGroupData';
import { getMoSupplierTable } from 'constants/mo';
import { formatSupplierData } from 'utils/shared/my-order';
import withErrorBoundary from '../withErrorBoundary';
import { MainContext } from 'contexts/MainContext';
import { Column } from 'ts/shared/interfaces/Generic';

interface MoSupplierProps {
  myOrder: MyOrder;
  supplier?: MoSupp;
}

const MoSupplier: FC<MoSupplierProps> = ({ myOrder, ...props }) => {
  const { fullSegment: segment } = myOrder;
  const [t] = useTranslation();
  const [data, setData] = useState<MoSupplierData>();
  const { user } = useContext(MainContext);

  useEffect(() => {
    if (props.supplier) {
      setData(formatSupplierData(props.supplier, myOrder));
    }
  }, [props.supplier]); // eslint-disable-line

  const pnrColumns: Column[] = useMemo(
    () => [
      { label: t('mo.pnr'), field: 'pnr', className: 'mo-group-data-bold' },
      { label: `${t('mo.pnr')} ${t('mo.segment')}`, field: 'pnrSeg', className: 'mo-group-data-bold' },
      { label: t('mo.pnr_ref'), field: 'pnrRef' },
    ],
    [t]
  );

  const pnrData = useMemo(
    () => ({
      pnr: segment.suppPnrWithOutLock,
      pnrSeg: segment.suppPnrSeg,
      pnrRef: segment.suppPnrSegConRef,
    }),
    [segment.suppPnrWithOutLock, segment.suppPnrSeg, segment.suppPnrSegConRef]
  );

  return (
    <Fragment>
      <div className="mb-20">
        {user?.branch?.hotelDisplaySupplierName && (
          <div className="mb-10 mo-tabs-row pv-7">
            <span>{t('mo.supplier_full')} </span>
            <span className="text-bold">
              {segment.sysSuppDesc} ({segment.sysSuppCode})
            </span>
          </div>
        )}
        <MoGroupData
          columns={pnrColumns}
          data={pnrData}
          columnsCount={1}
          columnWidth={110}
          mainClassName="mo-group-wr-1x"
        />

        {!!data && (
          <div className="mt-20">
            <MoGroupData
              columns={getMoSupplierTable(!user?.branch?.hotelDisplaySupplierName)}
              data={data}
              columnsCount={2}
              columnWidth={130}
              mainClassName="mo-group-wr-2x mo-group-wr-amount"
            />
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default withErrorBoundary(MoSupplier, 'MoSupplier');
